import {Controller} from '@hotwired/stimulus';
import {application} from 'src';
import './component.scss';

application.register(
  'line-prices-box',
  class extends Controller {
    togglePrices() {
      let prices = document.getElementById('hidden-prices');
      let showPlans = document.getElementById('show-plans');
      let hidePlans = document.getElementById('hide-plans');

      prices.classList.toggle('prices');
      hidePlans.classList.toggle('hide-plan-fade');
      showPlans.classList.toggle('hide-plan-fade');
    }
  }
);
